module.exports = __webpack_public_path__ + "static/img/light.298fe11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/light/light.png
// module id = x476
// module chunks = 1